import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Col, Label, Row, CardHeader, Spinner, Input } from "reactstrap";
import swal from "sweetalert";
import { API_URL } from "app/config";
import {
  selectCurrentRoles,
  selectCurrentToken,
  selectCurrentUser,
} from "features/auth/authSlice";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { useAllDropDownDataQuery } from "services/dropdownApiSlice";
import {
  useGetBlockByDistrictQuery,
  useGetDistrictByStateQuery,
  useGetStatesQuery,
} from "services/locationApiSlice";

const KycDetailEdit = ({ SaathiUserData, SaathiDetailsRefetch }) => {
  const { id } = useParams();
  const user_token = useSelector(selectCurrentToken);
  const currentUser = useSelector(selectCurrentUser);
  const [kycEdit, setKycEdit] = useState(false);
  const [MaritalStatus, setMaritalStatus] = useState();
  const [Relationship, setRelationship] = useState();
  const [Occupation, setOccupation] = useState(null);
  const [loader, setLoader] = useState(false);
  const [selectedOccupation, setSelectedOccupation] = useState(null);
  const [selectedRelationship, setSelectedRelationship] = useState(null);
  const [stateList, setStateList] = useState([]);
  const [stateId, setStateId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtList, setDistrictList] = useState([]);
  const [districtName, setDistrictName] = useState("");
  const [districtId, setDistrictId] = useState(null);
  const [blockList, setBlockList] = useState([]);
  const [blockName, setBlockName] = useState("");
  const [blockId, setBlockId] = useState(null);
  const [noOfMember, setnoOfMember] = useState("");
  const [panselectedFile, setpanSelectedFile] = useState();
  const [otherselectedFile, setotherSelectedFile] = useState();
  const [aadharNumber, setaadharNumber] = useState("");
  const [profile, setProfile] = useState();
  const [date, setDate] = useState();
  const [OtherDocName, setOtherDocName] = useState([]);
  const [changeEvent, SetChangeEvent] = useState(null);
  const [otherDocumentNumber, setotherDocumentNumber] = useState("");

  const { data: dropdownitem } = useAllDropDownDataQuery();
  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId);
  const { data: dataBlock } = useGetBlockByDistrictQuery(districtId);
  const RolesFromToken = useSelector(selectCurrentRoles);

  function handlOtherDocName(OtherDocName) {
    setOtherDocName(OtherDocName);
    SetChangeEvent(OtherDocName);
  }
  const otherchangeHandler = (event) => {
    setotherSelectedFile(event.target.files[0]);
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [PersonalDetails, editPersonalDetails] = useState({
    nomineeName: "",
    nomineeRelationship: "",
    noOfMember: "",
    dateOfBirth: "",
    gender: "",
    martialStatus: "",
    occupation: "",
    occupation_id: "",
    aadharNumber: "",
    panNumber: "",
    address: "",
    city: "",
    city_id: "",
    state: "",
    state_id: "",
    district: "",
    district_id: "",
    pincode: "",
    aadhar_card: "",
    pan_card: "",
    profile_picture: "",
    other_document: "",
    other_document_type: "",
  });

  const onInputChange = (event) => {
    editPersonalDetails({
      ...PersonalDetails,
      [event.target.name]: event.target.value,
    });
  };
  const MaritalStatusList = [
    {
      label: "Status",
      options: [
        { value: "single", label: "Unmarried" },
        { value: "married", label: "Married" },
        { value: "divorced", label: "Divorced" },
        { value: "Widow / widower", label: "Widower / widower" },
      ],
    },
  ];
  const noOfMemberhandleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setnoOfMember(value);
  };
  const profilechangeHandler = (event) => {
    setProfile(event.target.files[0]);
  };
  const aadharNumberhandleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setaadharNumber(value);
  };
  function handleMaritalStatus(MaritalStatus) {
    setMaritalStatus(MaritalStatus);
  }
  const handleRelationshipChange = (selectedOption) => {
    setRelationship(selectedOption);
    setSelectedRelationship(selectedOption.value);
  };
  const handleRelationOptions = () => {
    return dropdownitem?.data?.results[0]?.relations?.map((item) => ({
      value: item,
      label: item,
    }));
  };
  const handleOccupationChange = (selectedOption) => {
    setOccupation(selectedOption);
    setSelectedOccupation(selectedOption.value);
  };
  const handleOccupationOptions = () => {
    return dropdownitem?.data?.results[0]?.occupation?.map((item) => ({
      value: item,
      label: item,
    }));
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 40,
    }),
  };

  useEffect(() => {
    if (getStates !== undefined) {
      setStateList(getStates?.data?.results);
    }
  }, [getStates]);

  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };

  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };
  const handleBlockOptions = () => {
    let responseAgentArray = [];
    blockList.map((block) => {
      responseAgentArray.push({
        value: block.block_code,
        label: block.block_name,
        ConditionName: "block",
      });
    });
    return responseAgentArray;
  };
  const onLocationChange = (event) => {
    if (event.ConditionName == "state") {
      setBlockId(null);
      setDistrictName("");
      setDistrictId(null);
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId(null);
      setBlockName("");
    }
    if (event.ConditionName == "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
  };
  useEffect(() => {
    // refetch()
  }, [stateId, districtId, blockId]);
  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock != undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);

  var otherdoc = PersonalDetails.OtherDocName === undefined ? "" : OtherDocName;
  var otherDocNo =
    PersonalDetails.otherDocumentNumber === undefined
      ? ""
      : otherDocumentNumber;
  var otherselected = otherselectedFile === undefined ? "" : otherselectedFile;

  const onSubmitSaathiData = (data) => {
    setLoader(true);
    const formData = new FormData();
    formData.append(
      "nomineeName",
      PersonalDetails.nomineeName ||
        SaathiUserData?.personal_details?.nomineeName
    );
    formData.append(
      "nomineeRelationship",
      selectedRelationship ||
        SaathiUserData?.personal_details?.nomineeRelationship
    );
    formData.append(
      "noOfMember",
      noOfMember || SaathiUserData?.personal_details?.noOfMember
    );
    formData.append(
      "dateOfBirth",
      date || SaathiUserData?.personal_details?.dateOfBirth
    );
    formData.append(
      "gender",
      PersonalDetails.gender || SaathiUserData.personal_details.gender
    );
    formData.append(
      "martialStatus",
      MaritalStatus || SaathiUserData.personal_details.martialStatus
    );
    formData.append(
      "occupation",
      selectedOccupation || SaathiUserData.personal_details.occupation
    );
    formData.append(
      "aadharNumber",
      aadharNumber || SaathiUserData?.personal_details?.aadharNumber
    );
    formData.append(
      "panNumber",
      PersonalDetails.panNumber || SaathiUserData?.personal_details?.panNumber
    );
    formData.append(
      "address",
      PersonalDetails.address || SaathiUserData?.personal_details?.address
    );
    formData.append(
      "city",
      blockName || SaathiUserData?.personal_details?.city
    );
    formData.append("city_id", blockId);
    formData.append(
      "state",
      stateName || SaathiUserData?.personal_details?.state
    );
    formData.append("state_id", stateId);
    formData.append(
      "district",
      districtName || SaathiUserData?.personal_details?.district
    );
    formData.append("district_id", districtId);
    formData.append(
      "pincode",
      PersonalDetails.pincode || SaathiUserData?.personal_details?.pincode
    );
    formData.append("ui_section_id", "2");
    //  formData.append("aadhar_card", aadharselectedFile[0])

    // console.log(formData.aadhar_card + " dhehe")
    for (let a = 0; a < data.aadhar_card.length; a++) {
      formData.append("aadhar_card", data.aadhar_card[a]);
    }
    formData.append("profile_picture", profile);

    for (let d = 0; d < data.pan_card.length; d++) {
      formData.append("pan_card", data.pan_card[d]);
    }

    // formData.append("pan_card", panselectedFile)
    formData.append("other_document", otherselected || "");
    formData.append("otherDocumentNumber", otherDocNo || "");
    formData.append("other_document_type", otherdoc || "");
    formData.append("created_by", currentUser.sub);
    formData.append("created_by_name", currentUser.name);

    for (var pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    // console.log(JSON.stringify(aadharselectedFile) + " Adhar");

    var requestOptions = {
      method: "PUT",
      body: formData,
      headers: { Authorization: `Token ${user_token}` },
    };

    fetch(`${API_URL}/empanelment/api/kyc-details/${id}`, requestOptions)
      .then((r) => r.json())
      .then((resp) => {
        JSON.stringify(resp);
        const result = resp;

        if (result.status === 200 || result.status === 201) {
          swal("Success", {
            buttons: false,
            icon: "success",
            title: result.message,
            timer: 1500,
          });
          SaathiDetailsRefetch(id);
          setLoader(false);
          setKycEdit(false);
        } else {
          swal("Error", {
            buttons: false,
            icon: "warning",
            title: result.message,
            timer: 2000,
          });
          setLoader(false);
        }
      });
  };
  function capitalizeFirstLetter(string) {
    return string?.charAt(0).toUpperCase() + string?.slice(1);
  }
  useEffect(() => {
    if (SaathiUserData?.personal_details) {
      editPersonalDetails({ ...SaathiUserData?.personal_details });
    }
  }, [SaathiUserData?.personal_details]);

  const isPanCardAvailable = SaathiUserData?.all_media?.find(
    (item) => item.document_type == "Pan Card"
  );
  const isAadharCardAvailable = SaathiUserData?.all_media?.find(
    (item) => item.document_type == "Aadhar Card"
  );
  const isProfileAvailable = SaathiUserData?.all_media?.find(
    (item) => item.document_type == "Profile Picture"
  );

  return (
    <div>
      <CardHeader
        style={{ padding: "13px" }}
        className=" mb-3 d-flex justify-content-between align-items-center"
      >
        <h5 className="m-0">KYC Details</h5>

        {RolesFromToken.groups?.includes("Maker") ? (
          SaathiUserData?.onboarding_status === "QC1 Approved" ? (
            ""
          ) : (
            <div>
              {kycEdit ? (
                <Button
                  size="sm"
                  id="editDetails"
                  type=""
                  className=" btn-danger waves-effect  "
                  onClick={() => setKycEdit(false)}
                >
                  Cancel <i className="mdi mdi-window-close"></i>
                </Button>
              ) : (
                <Button
                  size="sm"
                  id="editDetails"
                  type=""
                  className="  waves-effect  "
                  onClick={() => setKycEdit(true)}
                >
                  Edit <i className="mdi mdi-file-edit-outline"></i>
                </Button>
              )}
            </div>
          )
        ) : (
          ""
        )}
      </CardHeader>

      <form onSubmit={handleSubmit(onSubmitSaathiData)}>
        <Row>
          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>Gender </Label>
              <div className="col-lg-12 p-0 d-flex mx-3">
                <div className="form-check ps-0 form-check-inline">
                  <input
                    name="gender"
                    id="male"
                    type="radio"
                    value="male"
                    readOnly
                    onChange={onInputChange}
                    checked={PersonalDetails.gender == "male"}
                  />
                  <Label htmlFor="male" className="ms-2">
                    Male
                  </Label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    name="gender"
                    id="female"
                    type="radio"
                    value="female"
                    readOnly
                    onChange={onInputChange}
                    checked={PersonalDetails.gender == "female"}
                  />
                  <Label htmlFor="female" className="ms-2">
                    Female
                  </Label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    name="gender"
                    id="other"
                    type="radio"
                    value="other"
                    readOnly
                    onChange={onInputChange}
                    checked={PersonalDetails.gender == "other"}
                  />
                  <Label htmlFor="other" className="ms-2">
                    other
                  </Label>
                </div>
              </div>
            </Col>
          ) : (
            <Col lg="3" className="mb-2">
              <Label>Gender </Label>
              <Input
                name=""
                defaultValue={SaathiUserData?.personal_details?.gender}
                disabled
                className="rounded-1"
                placeholder="Select Gender"
              />
            </Col>
          )}

          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>Date of Birth </Label>
              <input
                className="form-control rounded-1 "
                placeholder="YYYY-MM-DD"
                name="dateOfBirth"
                type="date"
                onChange={(e) => {
                  setDate(e.target.value);
                }}
                defaultValue={SaathiUserData?.personal_details?.dateOfBirth}
              />
            </Col>
          ) : (
            <Col lg="3" className="mb-2">
              <Label>Date of Birth </Label>
              <Input
                name=""
                defaultValue={SaathiUserData?.personal_details?.dateOfBirth}
                disabled
                className="rounded-1"
                placeholder="Enter DOB"
              />
            </Col>
          )}
          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>Select Martial Status </Label>
              <Select
                value={
                  MaritalStatus === undefined
                    ? MaritalStatus
                    : MaritalStatus.value
                }
                onChange={(MaritalStatus) => {
                  handleMaritalStatus(MaritalStatus.value);
                }}
                defaultValue=""
                options={MaritalStatusList}
                styles={customStyles}
                placeholder={
                  capitalizeFirstLetter(
                    SaathiUserData?.personal_details?.martialStatus
                  ) || "Select Martial Status"
                }
              />
            </Col>
          ) : (
            <Col lg="3" className="mb-2">
              <Label>Martial Status </Label>
              <Input
                name="martialStatus"
                defaultValue={SaathiUserData?.personal_details?.martialStatus}
                disabled
                className="rounded-1"
                placeholder="Enter Martial Status"
              />
            </Col>
          )}

          <Col lg="3" className="mb-2">
            <Label>Nominee Name</Label>
            <Input
              name="nomineeName"
              defaultValue={SaathiUserData?.personal_details?.nomineeName}
              disabled={kycEdit === true ? false : true}
              className="rounded-1"
              placeholder="Enter Nominee Name"
              onChange={onInputChange}
            />
          </Col>
          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>Select Relationship</Label>
              <Select
                value={Relationship}
                onChange={(e) => handleRelationshipChange(e)}
                options={handleRelationOptions()}
                styles={customStyles}
                placeholder={
                  capitalizeFirstLetter(
                    SaathiUserData?.personal_details?.nomineeRelationship
                  ) || "Select Nominee Relationship"
                }
              />
            </Col>
          ) : (
            <Col lg="3" className="mb-2">
              <Label>Nominee Relationship</Label>
              <Input
                name=""
                defaultValue={
                  SaathiUserData?.personal_details?.nomineeRelationship
                }
                disabled
                className="rounded-1"
                placeholder="Select Nominee RelationShip"
              />
            </Col>
          )}
          <Col lg="3" className="mb-2">
            <Label>No of Member </Label>
            <Input
              name="noOfMember"
              defaultValue={SaathiUserData?.personal_details?.noOfMember}
              disabled={kycEdit === true ? false : true}
              className="rounded-1"
              maxLength="2"
              onChange={noOfMemberhandleChange}
              placeholder="Enter No of member"
            />
          </Col>

          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>Select Occupation</Label>
              <Select
                value={Occupation}
                onChange={(e) => handleOccupationChange(e)}
                options={handleOccupationOptions()}
                styles={customStyles}
                placeholder={
                  capitalizeFirstLetter(
                    SaathiUserData?.personal_details?.occupation
                  ) || "Select Occupation"
                }
              />
            </Col>
          ) : (
            <Col lg="3" className="mb-2">
              <Label>Occupation </Label>
              <Input
                name=""
                defaultValue={SaathiUserData?.personal_details?.occupation}
                disabled
                className="rounded-1"
                placeholder="Select Occupation"
              />
            </Col>
          )}
          <Col lg="3" className="mb-2">
            <Label>Aadhar Number</Label>
            <Input
              name="aadharNumber"
              defaultValue={SaathiUserData?.personal_details?.aadharNumber}
              disabled={kycEdit === true ? false : true}
              className="rounded-1"
              onChange={aadharNumberhandleChange}
              placeholder="Enter Aadhar Number"
            />
          </Col>
          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>
                {" "}
                Aadhar card <small className="text-danger">*</small>
                <small>(Image Or Pdf Format Only*)</small>
              </Label>
              <input
                type="file"
                className="form-control rounded-1"
                name="aadhar_card"
                id="AddharImg"
                multiple
                accept="image/jpg,image/jpeg,image/png,application/pdf"
                filename="setaadharselectedFile"
                // onChange={aadharchangeHandler}
                {...register("aadhar_card", {})}
                required={isAadharCardAvailable?.filename !== "" ? false : true}
              />
            </Col>
          ) : (
            ""
          )}
          <Col lg="3" className="mb-2">
            <Label>Pan Number</Label>
            <Input
              name="panNumber"
              defaultValue={SaathiUserData?.personal_details?.panNumber}
              disabled={kycEdit === true ? false : true}
              className="rounded-1"
              onChange={onInputChange}
              placeholder="Enter PAN Number"
            />
          </Col>
          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>
                {" "}
                Pan card <small className="text-danger">*</small>
                <small>(Image Or Pdf Format Only*)</small>
              </Label>
              <input
                type="file"
                className="form-control rounded-1"
                name="pan_card"
                accept=" image/jpeg,image/png,application/pdf"
                filename="panselectedFile"
                {...register("pan_card")}
                required={isPanCardAvailable?.filename !== "" ? false : true}
              />
            </Col>
          ) : (
            ""
          )}
          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>
                {" "}
                Profile Image <small className="text-danger">*</small>
              </Label>
              <input
                type="file"
                className="form-control input_text rounded-1"
                name="profile_picture"
                accept="image/jpeg, image/png,image/jpg"
                filename="panselectedFile"
                onChange={profilechangeHandler}
                required={isProfileAvailable ? false : true}
              />
            </Col>
          ) : (
            ""
          )}

          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>Select State</Label>
              <Select
                options={handleStateOptions()}
                onChange={onLocationChange}
                placeholder={
                  capitalizeFirstLetter(
                    SaathiUserData?.personal_details?.state
                  ) || "Select State"
                }
                styles={customStyles}
              />
            </Col>
          ) : (
            <Col lg="3" className="mb-2">
              <Label>State</Label>
              <Input
                name=""
                defaultValue={SaathiUserData?.personal_details?.state}
                disabled
                className="rounded-1"
                placeholder="Select State"
              />
            </Col>
          )}
          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label> Select District</Label>
              <Select
                options={handleDistrictOptions()}
                onChange={onLocationChange}
                placeholder={
                  capitalizeFirstLetter(
                    SaathiUserData?.personal_details?.district
                  ) || "Select District"
                }
                styles={customStyles}
              />
            </Col>
          ) : (
            <Col lg="3" className="mb-2">
              <Label>District</Label>
              <Input
                name=""
                defaultValue={SaathiUserData?.personal_details?.district}
                disabled
                className="rounded-1"
                placeholder="Select District"
              />
            </Col>
          )}
          {kycEdit === true ? (
            <Col lg="3" className="mb-2">
              <Label>Select Block</Label>
              <Select
                options={handleBlockOptions()}
                placeholder={
                  capitalizeFirstLetter(
                    SaathiUserData?.personal_details?.city
                  ) || "Select Block"
                }
                onChange={onLocationChange}
                styles={customStyles}
              />
            </Col>
          ) : (
            <Col lg="3" className="mb-2">
              <Label>Block</Label>
              <Input
                name=""
                defaultValue={SaathiUserData?.personal_details?.city}
                disabled
                className="rounded-1"
                placeholder="Select Block"
              />
            </Col>
          )}
          <Col lg="3" className="mb-2">
            <Label>Address</Label>
            <Input
              name="address"
              defaultValue={SaathiUserData?.personal_details?.address}
              disabled={kycEdit === true ? false : true}
              className="rounded-1"
              placeholder="Enter Address"
              onChange={onInputChange}
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Pincode</Label>
            <Input
              name="pincode"
              defaultValue={SaathiUserData?.personal_details?.pincode}
              disabled={kycEdit === true ? false : true}
              className="rounded-1"
              placeholder="Enter Pincode"
              onChange={onInputChange}
            />
          </Col>
          {/* <Col lg="3" className="mb-2">
            <Label>Onboarding Status</Label>
            <Input
              name=""
              defaultValue={SaathiUserData?.onboarding_status}
              disabled
              className="rounded-1"
            />
          </Col> */}
          {kycEdit === true ? (
            <div className="col-lg-12 text-center m-auto p-2">
              <button type="submit" className="btn btn-success p-3">
                <span class="mdi mdi-content-save "></span> Update KYC Details
                &nbsp;
                {loader ? <Spinner animation="border" size="sm"></Spinner> : ""}
              </button>
            </div>
          ) : (
            ""
          )}
        </Row>
      </form>
    </div>
  );
};

export default KycDetailEdit;
